export const booking_page_events = {
  booking_flight_checkbox_click: {
    category: "Only flights will listing if user selects only the flight option",
    action: "User clicks on flight checkbox",
    label: "booking-form-flights-click",
  },
  booking_hotel_checkbox_click: {
    category: "Only hotels will listing if user selects only the flight option",
    action: "User clicks on hotel checkbox",
    label: "booking-form-stays-click",
  },
  booking_flight_hotel_checkbox_click: {
    category: "Both flights and hotels will be listed if user selects both the checkbox",
    action: "User clicks on the flight and hotel checkboxs",
    label: "booking-form-flights-stays-click",
  },

  booking_flights_search_login_click: {
    category: "Booking flights",
    action: "User clicks login from flight search",
    label: "booking-flights-search-login-click",
  },
  booking_stays_search_login_click: {
    category: "Booking stays",
    action: "User clicks login from stays search",
    label: "booking-stays-search-login-click",
  },

  booking_flights_search_click: {
    category: "User searches for flights",
    action: "",
    label: "booking-form-flights-search-click",
  },
  searchFlights: {
    category: "User searches for flights",
    action: "User clicks on search button",
    label: "searchFlights",
  },
  booking_flights_cancel_search_click: {
    category: "Booking flights interaction",
    action: "User cancels a flight search",
    label: "booking-flights-cancel-search-click",
  },
  booking_hotels_cancel_search_click: {
    category: "Booking hotels interaction",
    action: "User cancels a hotel search",
    label: "booking-stays-cancel-search-click",
  },

  booking_flights_details_view_click: {
    category: "User is checking the flight details",
    action: "User clicks on flight details view",
    label: "flights-details-view-click",
  },
  booking_flights_details_view_close: {
    category: "User is close the flight details",
    action: "User clicks on flight close details",
    label: "flights-details-view-close",
  },
  booking_flights_selecting_click: {
    category: "User is selecting the flight",
    action: "User clicks select flight with price",
    label: "booking-flights-selecting-click",
  },
  booking_flights_select_fares_opt_click: {
    category: "Booking Flights",
    action: "User selects a fare option for flights",
    label: "booking-flights-select-fares-opt-click",
  },
  booking_flights_avail_cancel_click: {
    category: "Booking Flights",
    action: "User cancels flight availability check",
    label: "booking-flights-avail-cancel-click",
  },
  booking_flights_avail_success: {
    category: "Booking Flights",
    action: "Flight availability check successful",
    label: "booking-flights-avail-success",
  },

  reviewCart: {
    category: "User is selecting the flight",
    action: "User clicks select flight with price",
    label: "reviewCart",
  },
  booking_stays_search_click: {
    category: "User searches for hotels",
    action: "",
    label: "booking-form-stays-search-click",
  },
  booking_flights_search_click_auto: {
    category: "Booking Flights",
    action: "Flight search triggered automatically",
    label: "booking-flights-search-click-auto",
  },
  booking_stays_search_click_auto: {
    category: "Booking Stays",
    action: "Stays search triggered automatically",
    label: "booking-stays-search-click-auto",
  },
  searchStays: {
    category: "User searches for hotels",
    action: "User clicks on search button",
    label: "searchStays",
  },
  booking_hotels_view_details_click: {
    category: "User is checking the hotel details",
    action: "User clicks on hotel view details",
    label: "booking-stays-view-details-click",
  },
  booking_hotels_view_room_details_click: {
    category: "User is checking the hotel details",
    action: "User clicks on hotel view room details",
    label: "booking-stays-room-details-open-click",
  },
  booking_hotels_selecting_click: {
    category: "User is selecting the hotel",
    action: "User clicks select hotel with price",
    label: "booking-stays-selecting-click",
  },
  booking_chat_activity_result_click: {
    category: "Booking",
    action: "User clicks an activity card in the in-chat activity search results",
    label: "booking-chat-activity-result-click",
  },
  booking_chat_flight_stay_result_click: {
    category: "Booking",
    action: "User commits to a chat-originated combined flight + stay package at prebook (Next: Payment Method)",
    label: "booking-chat-flight-stay-result-click",
  },
  booking_chat_flight_result_click: {
    category: "Booking",
    action: "User clicks a flight card in the in-chat flight search results (chat-origin only)",
    label: "booking-chat-flight-result-click",
  },
  post_booking_hotels_selecting_click: {
    category: "User is selecting the hotel",
    action: "User clicks select hotel with price",
    label: "post-booking-stays-selecting-click",
  },
  booking_stays_room_pic_change_click: {
    category: "Booking Stays",
    action: "User changes room picture in stays booking",
    label: "booking-stays-room-pic-change-click",
  },
  booking_stays_avail_cancel_click: {
    category: "Booking Stays",
    action: "User cancels stay availability check",
    label: "booking-stays-avail-cancel-click",
  },
  booking_stays_avail_success: {
    category: "Booking Stays",
    action: "Stay availability check successful",
    label: "booking-stays-avail-success",
  },
  booking_stays_pref_click: {
    category: "Booking Stays",
    action: "User clicks stays preferences",
    label: "booking-stays-pref-click",
  },
  booking_stays_details_cancel_click: {
    category: "Booking Stays",
    action: "User cancels stays details view",
    label: "booking-stays-details-cancel-click",
  },
  booking_stays_details_pic_change_click: {
    category: "Booking Stays",
    action: "User changes picture in stays details",
    label: "booking-stays-details-pic-change-click",
  },
  bookings_stays_amenities_close_click: {
    category: "Booking Stays",
    action: "User closes amenities in stays booking",
    label: "bookings-stays-amenities-close-click",
  },
  booking_stays_less_rates_click: {
    category: "Booking Stays",
    action: "User views fewer room rates in stays booking",
    label: "booking-stays-less-rates-click",
  },

  booking_flight_ask_zoya: {
    category: "User click on ask zoya button",
    action: "User click on ask zoya button in flight section",
    label: "booking-flights-ask-zoya-click",
  },
  booking_hotel_ask_zoya: {
    category: "User click on ask zoya button",
    action: "User click on ask zoya button in hotel section",
    label: "booking-stays-ask-zoya-click",
  },
  booking_ask_zoya_sending_llm_question: {
    category: "User asking question to zoya",
    action: "User click send button to ask question to zoya",
    label: "ask-zoya-send-click",
  },
  booking_ask_zoya_input_click: {
    category: "Booking assistance",
    action: "User clicks on ask Zoya input",
    label: "ask-zoya-input-click",
  },
  ask_zoya_prompt_click: {
    category: "Ask Zoya",
    action: "User clicks on Ask Zoya prompt",
    label: "ask-zoya-prompt-click",
  },
  ask_zoya_mic_record_click: {
    category: "Ask Zoya",
    action: "User starts voice recording in Ask Zoya",
    label: "ask-zoya-mic-record-click",
  },
  ask_zoya_mic_stop_record_click: {
    category: "Ask Zoya",
    action: "User stops voice recording in Ask Zoya",
    label: "ask-zoya-mic-stop-record-click",
  },
  ask_zoya_input_stop_click: {
    category: "Ask Zoya",
    action: "User stops Ask Zoya input",
    label: "ask-zoya-input-stop-click",
  },

  ask_zoya_scroll_down_click: {
    category: "Ask Zoya",
    action: "User clicks scroll down in Ask Zoya",
    label: "ask-zoya-scroll-down-click",
  },

  ask_zoya_try_again_click: {
    category: "Ask Zoya",
    action: "User clicks on try again when process is interrupted",
    label: "ask-zoya-try-again-click",
  },

  booking_ask_zoya_closed: {
    category: "User closing ask zoya",
    action: "User click on close button to close ask zoya",
    label: "ask-zoya-close-click",
  },

  booking_selected_hotel_removed: {
    category: "User removed selected hotel",
    action: "User click on removed selected hotel button",
    label: "review-cart-stays-rmv-click",
  },

  booking_selected_flight_removed: {
    category: "User removed selected flight",
    action: "User click on removed selected flight button",
    label: "review-cart-flights-rmv-click",
  },

  booking_stays_continue_click: {
    category: "User clicks on continue button",
    action: "User navigates to hotel search",
    label: "booking-stays-continue-click",
  },
  booking_flights_continue_click: {
    category: "User clicks on continue button",
    action: "User navigates to hotel search",
    label: "booking-flights-continue-click",
  },
  booking_review_cart_checkout_click: {
    category: "User clicks on continue button",
    action: "User navigates to review cart search",
    label: "review-cart-checkout-click",
  },
  review_cart_price_info_hover: {
    category: "Review Cart - Price Info",
    action: "User hovers over price info in review cart",
    label: "review-cart-price-info-hover",
  },

  booking_continue_to_traveler_click: {
    category: "User clicks on continue button",
    action: "User navigates to traveler form search",
    label: "booking-continue-to-traveler-form-click",
  },
  booking_travelers_continue_click: {
    category: "User clicks on continue button",
    action: "User navigates to checkout search",
    label: "traveler-info-continue-click",
  },
  traveler_info_room_assignment_click: {
    category: "Traveler Info",
    action: "User clicks room assignment in traveler information",
    label: "traveler-info-room-assignment-click",
  },


  booking_success: {
    category: "Booking success",
    action: "Booking success information",
    label: "payment-pay-success",
  },
  payment_total_accordion_expand: {
    category: "Payment",
    action: "User expands total payment accordion",
    label: "payment-total-accordion-expand",
  },
  payment_info_message_us_click: {
    category: "Payment Info",
    action: "When user clicks on the info card 'message us' hyperlink",
    label: "payment-info-message-us-click",
  },
  payment_total_accordion_collapse: {
    category: "Payment",
    action: "User collapses total payment accordion",
    label: "payment-total-accordion-collapse",
  },

  paymentComplete: {
    category: "Booking success",
    action: "Booking success information",
    label: "paymentComplete",
  },
  booking_failure: {
    category: "Booking failure",
    action: "Booking failure information",
    label: "payment-pay-failure",
  },

  booking_promo_code_input: {
    category: "Booking - Promo Code",
    action: "User enters a promo code",
    label: "payment-promo-code-input-click",
  },
  booking_promo_code_apply: {
    category: "Booking - Promo Code",
    action: "User applies a promo code",
    label: "payment-promo-code-apply-click",
  },
  booking_promo_code_success: {
    category: "Booking - Promo Code",
    action: "Promo code applied successfully",
    label: "payment-promo-code-success",
  },
  promoCode: {
    category: "Booking - Promo Code",
    action: "Promo code applied successfully",
    label: "promoCode",
  },
  booking_promo_code_fail: {
    category: "Booking - Promo Code",
    action: "Promo code application failed",
    label: "payment-promo-code-fail",
  },
  booking_attempt: {
    category: "Booking",
    action: "User attempts to complete a booking",
    label: "payment-pay-click",
  },
  booking_promo_code_remove_click: {
    category: "Booking - Promo Code",
    action: "Promo code removed click",
    label: "payment-promo-code-rmv-click",
  },
  booking_promo_code_remove_success: {
    category: "Booking - Promo Code",
    action: "Promo code removed successfully",
    label: "payment-promo-code-rmv-success",
  },
  booking_promo_code_remove_fail: {
    category: "Booking - Promo Code",
    action: "Promo code removal failed",
    label: "payment-promo-code-rmv-fail",
  },

  booking_payment_back_click: {
    category: "Booking",
    action: "User goes back from payment screen",
    label: "payment-back-click",
  },
  booking_travelers_back_click: {
    category: "Booking navigation",
    action: "User goes back from traveler form",
    label: "traveler-info-back-click",
  },
  booking_review_cart_back_click: {
    category: "Booking navigation",
    action: "User goes back from review cart form",
    label: "review-cart-back-click",
  },
  review_cart_stays_details_view: {
    category: "Review Cart - Stays",
    action: "User views stay details in review cart",
    label: "review-cart-stays-details-view",
  },
  review_cart_stays_map_open_click: {
    category: "Review Cart - Stays",
    action: "User opens stay map",
    label: "review-cart-stays-map-open-click",
  },
  review_cart_stays_map_close_click: {
    category: "Review Cart - Stays",
    action: "User closes stay map",
    label: "review-cart-stays-map-close-click",
  },
  review_cart_stay_map_zoom_in_click: {
    category: "Review Cart - Stays",
    action: "User zooms in on stay map",
    label: "review-cart-stay-map-zoom-in-click",
  },
  review_cart_stays_map_zoom_out_click: {
    category: "Review Cart - Stays",
    action: "User zooms out on stay map",
    label: "review-cart-stays-map-zoom-out-click",
  },
  review_cart_stays_pic_change_click: {
    category: "Review Cart - Stays",
    action: "User changes stay image",
    label: "review-cart-stays-pic-change-click",
  },
  review_cart_stays_amenities_open_click: {
    category: "Review Cart - Stays",
    action: "User opens stay amenities",
    label: "review-cart-stays-amenities-open-click",
  },
  review_cart_stays_amenities_close_click: {
    category: "Review Cart - Stays",
    action: "User closes stay amenities",
    label: "review-cart-stays-amenities-close-click",
  },
  review_cart_stays_slct_room_click: {
    category: "Review Cart - Stays",
    action: "User selects a room from review cart",
    label: "review-cart-stays-slct-room-click",
  },
  review_cart_stays_slct_rooms_close_click: {
    category: "Review Cart - Stays",
    action: "User closes room selection modal",
    label: "review-cart-stays-slct-rooms-close-click",
  },
  review_cart_stays_room_dtls_open_click: {
    category: "Review Cart - Stays",
    action: "User opens room details",
    label: "review-cart-stays-room-dtls-open-click",
  },
  review_cart_stays_room_dtls_close_click: {
    category: "Review Cart - Stays",
    action: "User closes room details",
    label: "review-cart-stays-room-dtls-close-click",
  },
  review_cart_stays_more_rates_click: {
    category: "Review Cart - Stays",
    action: "User views more room rates",
    label: "review-cart-stays-more-rates-click",
  },
  review_cart_stays_less_rates_click: {
    category: "Review Cart - Stays",
    action: "User views fewer room rates",
    label: "review-cart-stays-less-rates-click",
  },
  review_cart_stays_cncl_plcy_open_click: {
    category: "Review Cart - Stays",
    action: "User opens cancellation policy",
    label: "review-cart-stays-cncl-plcy-open-click",
  },
  review_cart_stays_cncl_plcy_close_click: {
    category: "Review Cart - Stays",
    action: "User closes cancellation policy",
    label: "review-cart-stays-cncl-plcy-close-click",
  },
  review_cart_stays_room_pic_change_click: {
    category: "Review Cart - Stays",
    action: "User changes room image",
    label: "review-cart-stays-room-pic-change-click",
  },

  booking_stays_back_click: {
    category: "Booking navigation",
    action: "User goes back from stays search form",
    label: "booking-stays-back-click",
  },
  booking_flights_back_click: {
    category: "Booking navigation",
    action: "User goes back from flight search form",
    label: "booking-flights-back-click",
  },

  booking_discard_changes: {
    category: "Booking",
    action: "User chooses to discard unsaved changes",
    label: "discard-changes-discard-click",
  },
  booking_discard_cancel: {
    category: "Booking",
    action: "User cancels the discard changes action",
    label: "discard-changes-cancel-click",
  },

  booking_cart_click: {
    category: "Booking",
    action: "User clicks on cart",
    label: "booking-form-cart-click",
  },
  payment_tos_accept_click: {
    category: "Booking",
    action: "User clicks accopt terms of service",
    label: "payment-tos-accept-click",
  },

  // Review Cart page events
  review_cart_cancel_policy_open_click: {
    category: "Review Cart",
    action: "User opens cancellation policy",
    label: "review-cart-cancel-policy-open-click",
  },
  review_cart_cancel_policy_close_click: {
    category: "Review Cart",
    action: "User closes cancellation policy",
    label: "review-cart-cancel-policy-close-click",
  },
  review_cart_logo_click: {
    category: "Review Cart",
    action: "User clicks on the logo",
    label: "review-cart-logo-click",
  },
  review_cart_leave_close_click: {
    category: "Review Cart - Leave Dialog",
    action: "User closes the leave dialog",
    label: "review-cart-leave-close-click",
  },
  review_cart_leave_cancel_click: {
    category: "Review Cart - Leave Dialog",
    action: "User cancels leaving from the leave dialog",
    label: "review-cart-leave-cancel-click",
  },
  review_cart_leave_leave_click: {
    category: "Review Cart - Leave Dialog",
    action: "User confirms leaving from the leave dialog",
    label: "review-cart-leave-leave-click",
  },
  review_cart_need_help_click: {
    category: "Review Cart",
    action: "User clicks on need help",
    label: "review-cart-need-help-click",
  },
  review_cart_need_help_message_click: {
    category: "Review Cart",
    action: "User clicks on message us in need help",
    label: "review-cart-need-help-message-click",
  },
  review_cart_bottom_drawer_open: {
    category: "Review Cart",
    action: "User opens the bottom drawer",
    label: "review-cart-bottom-drawer-open",
  },
  review_cart_bottom_drawer_close: {
    category: "Review Cart",
    action: "User closes the bottom drawer",
    label: "review-cart-bottom-drawer-close",
  },

  // Traveler Info page events
  traveler_info_mod_stays_click: {
    category: "Traveler Info - Modify Stays",
    action: "User clicks modify stays",
    label: "traveler-info-mod-stays-click",
  },
  traveler_info_mod_stays_close_click: {
    category: "Traveler Info - Modify Stays",
    action: "User closes the modify stays dialog",
    label: "traveler-info-mod-stays-close-click",
  },
  traveler_info_mod_stays_cncl_click: {
    category: "Traveler Info - Modify Stays",
    action: "User cancels the modify stays dialog",
    label: "traveler-info-mod-stays-cncl-click",
  },
  traveler_info_mod_stays_cart_click: {
    category: "Traveler Info - Modify Stays",
    action: "User goes to cart from modify stays dialog",
    label: "traveler-info-mod-stays-cart-click",
  },
  traveler_info_mod_flight_click: {
    category: "Traveler Info - Modify Flight",
    action: "User clicks modify flight",
    label: "traveler-info-mod-flight-click",
  },
  traveler_info_mod_flight_close_click: {
    category: "Traveler Info - Modify Flight",
    action: "User closes the modify flight dialog",
    label: "traveler-info-mod-flight-close-click",
  },
  traveler_info_mod_flight_cncl_click: {
    category: "Traveler Info - Modify Flight",
    action: "User cancels the modify flight dialog",
    label: "traveler-info-mod-flight-cncl-click",
  },
  traveler_info_mod_flight_cart_click: {
    category: "Traveler Info - Modify Flight",
    action: "User goes to cart from modify flight dialog",
    label: "traveler-info-mod-flight-cart-click",
  },
  traveler_info_logo_click: {
    category: "Traveler Info",
    action: "User clicks on the logo",
    label: "traveler-info-logo-click",
  },
  traveler_info_leave_close_click: {
    category: "Traveler Info - Leave Dialog",
    action: "User closes the leave dialog",
    label: "traveler-info-leave-close-click",
  },
  traveler_info_leave_cancel_click: {
    category: "Traveler Info - Leave Dialog",
    action: "User cancels leaving from the leave dialog",
    label: "traveler-info-leave-cancel-click",
  },
  traveler_info_whats_this_for_open_click: {
    category: "Traveler Info",
    action: "User opens the what's this for tooltip",
    label: "traveler-info-whats-this-for-open-click",
  },
  traveler_info_whats_this_for_close_click: {
    category: "Traveler Info",
    action: "User closes the what's this for tooltip",
    label: "traveler-info-whats-this-for-close-click",
  },

  // Payment page events
  payment_tos_click: {
    category: "Payment",
    action: "User clicks on terms of service link",
    label: "payment-tos-click",
  },
  payment_mod_stays_click: {
    category: "Payment - Modify Stays",
    action: "User clicks modify stays",
    label: "payment-mod-stays-click",
  },
  payment_mod_stays_close_click: {
    category: "Payment - Modify Stays",
    action: "User closes the modify stays dialog",
    label: "payment-mod-stays-close-click",
  },
  payment_mod_stays_cncl_click: {
    category: "Payment - Modify Stays",
    action: "User cancels the modify stays dialog",
    label: "payment-mod-stays-cncl-click",
  },
  payment_mod_stays_cart_click: {
    category: "Payment - Modify Stays",
    action: "User goes to cart from modify stays dialog",
    label: "payment-mod-stays-cart-click",
  },
  payment_mod_flight_click: {
    category: "Payment - Modify Flight",
    action: "User clicks modify flight",
    label: "payment-mod-flight-click",
  },
  payment_mod_flight_close_click: {
    category: "Payment - Modify Flight",
    action: "User closes the modify flight dialog",
    label: "payment-mod-flight-close-click",
  },
  payment_mod_flight_cncl_click: {
    category: "Payment - Modify Flight",
    action: "User cancels the modify flight dialog",
    label: "payment-mod-flight-cncl-click",
  },
  payment_mod_flight_cart_click: {
    category: "Payment - Modify Flight",
    action: "User goes to cart from modify flight dialog",
    label: "payment-mod-flight-cart-click",
  },
  payment_logo_click: {
    category: "Payment",
    action: "User clicks on the logo",
    label: "payment-logo-click",
  },
  payment_leave_close_click: {
    category: "Payment - Leave Dialog",
    action: "User closes the leave dialog",
    label: "payment-leave-close-click",
  },
  payment_leave_cancel_click: {
    category: "Payment - Leave Dialog",
    action: "User cancels leaving from the leave dialog",
    label: "payment-leave-cancel-click",
  },
  payment_leave_leave_click: {
    category: "Payment - Leave Dialog",
    action: "User confirms leaving from the leave dialog",
    label: "payment-leave-leave-click",
  },
  payment_bottom_drawer_open_click: {
    category: "Payment",
    action: "User opens the bottom drawer",
    label: "payment-bottom-drawer-open-click",
  },
  payment_bottom_drawer_close_click: {
    category: "Payment",
    action: "User closes the bottom drawer",
    label: "payment-bottom-drawer-close-click",
  },
  traveler_info_bottom_drawer_open: {
    category: "Traveler Info",
    action: "User opens bottom drawer in traveler information",
    label: "traveler-info-bottom-drawer-open",
  },
  traveler_info_bottom_drawer_close: {
    category: "Traveler Info",
    action: "User closes bottom drawer in traveler information",
    label: "traveler-info-bottom-drawer-close",
  },

};
